<div class="info-group customer">
  <div class="label">{{ 'TYPE' }}</div>
  <div class="value cmp-name">{{ 'B2B Customer' }}</div>
</div>
<div class="info-group customer">
  <div class="label">{{ 'unitSelection.company' | cxTranslate }}</div>
  <div class="value">{{ list?.name }}</div>
</div>
<div class="info-group customer">
  <div class="label">{{ 'unitSelection.customer' | cxTranslate }}</div>
  <div class="value">{{ list?.uid }}</div>
</div>
<button
  class="btn btn-primary btn-block start-session"
  (click)="setB2Bunit(list?.uid)"
  [disabled]="list.active ? false : true"
>
  {{ 'unitSelection.start' | cxTranslate }}
</button>
